'use client';

import { RouteError } from '@/components/route-error';

/**
 * Connect0 skill §Q.9 — per-route error boundary. Catches anything
 * thrown during the render of this segment's page (or any nested
 * route) so the failure isolates to this slot. The authed shell
 * (sidebar + header) stays mounted because this boundary sits inside
 * the layout tree.
 */
export default function RouteErrorBoundary(props: { error: Error & { digest?: string }; reset: () => void }) {
  return <RouteError {...props} label="Guide" />;
}
